import React from "react";
import { Dialog, AppBar, Toolbar, IconButton, Typography, Slide } from "@mui/material";
import { Close } from "@mui/icons-material";

import "./FullScreenDialog.styl";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
});

export default function FullScreenDialog({ children, open, onClose, title, className, ...rest }) {
    className = typeof className === "string" ? " " + className : "";
    return (
        <Dialog fullScreen open={open} onClose={onClose} className={`FullScreenDialog${className}`} TransitionComponent={Transition} {...rest}>
            <AppBar className="AppBar">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={onClose} aria-label="Close">
                        <Close />
                    </IconButton>
                    <Typography variant="h6" color="inherit">
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
            {children}
        </Dialog>
    );
}
